import {
  Box,
  Rating,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import React from "react";
import { HandleSkeletion } from "../../../../../utils/constants";
import {
  DotColor,
  StatusChange,
  StyledTableBodyTableCell,
  StyledTableTitleTableCell,
  TableContainerBorder,
} from "../../../../common-components/StyledComponents";

const headerData = ["Capability / Skill ", "Importance", "Coverage", "Owners"];

const educationData = [
  {
    id: 5.0,
    skill: "Vision & Customer Strategy",
    importance: "Critical",
    coverage: "Strong",
    owner: "Zahir",
  },
  {
    id: 5.0,
    skill: "Product Management & UX",
    importance: "Critical",
    coverage: "Strong",
    owner: "Phoenix",
  },
  {
    id: 4.2,
    skill: "Program Execution & Delivery",
    coverage: "Very Strong",
    importance: "Critical",
    owner: "Jacob, Lana",
  },
  {
    id: 3.9,
    skill: "Technology Architecture & Integration",
    coverage: "Moderate",
    importance: "High",
    owner: "Jane",
  },
  {
    id: 4.6,
    skill: "Data, Analytics & Personalization",
    importance: "High",
    coverage: "Moderate",
    owner: "Jenny",
  },
  {
    id: 4.2,
    skill: "Marketing, Loyalty & Engagement",
    importance: "Medium",
    coverage: "Moderate",
    owner: "Ethan",
  },
  {
    id: 3.2,
    skill: "Change Management & Adoption",
    importance: "Medium",
    coverage: "Moderate",
    owner: "Sophia",
  },
  {
    id: 4.5,
    skill: "Retail Ops / Store Integration",
    importance: "High",
    coverage: "Moderate",
    owner: "Gap",
  },
  {
    id: 4.5,
    skill: "Vendor / Partner Management",
    importance: "Medium",
    coverage: "Weak",
    owner: "Gap",
  },
];

export const getColor = (name) => {
  let color;
  if (name === "High" || name === "Moderate") {
    color = "#F79009";
  } else if (name === "Critical" || name === "Weak") {
    color = "#F04438";
  } else if (name === "Medium" || name === "Strong") {
    color = "#0070F2";
  } else {
    color = "green";
  }

  return color;
};

function Skills({ isLoading }) {
  return (
    <>
      <TableContainerBorder marginTop="0px">
        <Table>
          <TableHead style={{ backgroundColor: "#F9FAFB" }}>
            <TableRow>
              {headerData.map((item, index) => (
                <StyledTableTitleTableCell key={index}>
                  {item}
                </StyledTableTitleTableCell>
              ))}
            </TableRow>
          </TableHead>
          {isLoading ? (
            <>
              {Array.from({ length: 3 }).map((_, rowIndex) => (
                <TableRow key={rowIndex}>
                  {Array.from({ length: headerData.length }).map(
                    (_, colIndex) => (
                      <TableCell key={colIndex}>
                        <HandleSkeletion height={30} />
                      </TableCell>
                    )
                  )}
                </TableRow>
              ))}
            </>
          ) : (
            <TableBody>
              {educationData.map((row) => (
                <TableRow key={row.id}>
                  <StyledTableBodyTableCell>
                    {row.skill}
                  </StyledTableBodyTableCell>
                  <TableCell>
                    <StatusChange>
                      <DotColor color={getColor(row.importance)} />
                      {row.importance}
                    </StatusChange>
                  </TableCell>
                  <TableCell>
                    <StatusChange>
                      <DotColor color={getColor(row.coverage)} />
                      {row.coverage}
                    </StatusChange>
                  </TableCell>
                  <TableCell>{row.owner}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          )}
        </Table>
      </TableContainerBorder>
    </>
  );
}

export default Skills;
